export const PUBLIC_NAV_BAR_SCHEMA = {
  en: {
    pub: {
      link1: {
        text: "What We Offer",
      },
      link2: {
        text: "Who We Help",
      },
      link3: {
        text: "Our Blog",
      },
      cta_1: {
        text: "Sign In",
      },
      cta_2: {
        text: "Sign Up",
      },
    },
    pri: {
      services: {
        heading: "Tax Filing",
        tax_filing: {
          text: "With an Expert",
        },
      },
      financial_insights: {
        heading: "Financial Insights",
        insights_hub: {
          text: "Insights Hub",
        },
        personal_finances: {
          text: "Personal Finances",
        },
      },
      engagement: {
        heading: "Engagement",
        refer_friend: {
          text: "Refer a Friend",
        },
        decoded_plaintr: {
          text: "Decoded By Plaintr",
        },
        become_affiliate: {
          text: "Become an Affiliate",
        },
        affiliates: {
          text: "Affiliates",
        },
      },
      help_support: {
        heading: "Help & Support",
        contact_support: {
          text: "Contact Support",
        },
        help_center: {
          text: "Help Center",
        },
      },
    },
  },
};
